import { setBankData, setAccountsWithOnb, setAccountBalance } from "./slice";

export const setBankHome = (data) => (dispatch) => {
  dispatch(setBankData(data));
};

export const setAccounts = (data) => (dispatch) => {
  dispatch(setAccountsWithOnb(data));
};

export const setBalance = (data) => (dispatch) => {
  dispatch(setAccountBalance(data));
};
